// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "h3[data-v-17bcd0fb]{margin:40px 0 0}ul[data-v-17bcd0fb]{list-style-type:none;padding:0}li[data-v-17bcd0fb]{display:inline-block;margin:0 10px}a[data-v-17bcd0fb]{color:#42b983}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
